var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-item"},[_c('label',[_vm._v("Groups")]),_c('nav',{staticClass:"nav flex-column"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'groups'}}},[_vm._v(" Groups ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }